var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-back",on:{"click":_vm.goBack}},[_c('svg-icon',{attrs:{"iconName":"back"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }